<div class="container-fluid page" *ngIf="datashow">
  <!-- <button mat-raised-button (click)="openDialog()">Pick city or food</button> -->
  <div class="d-flex page__box p-3 mt-2">
    &nbsp;&nbsp; User Management
    <div class="export_csv">
      <button
        class="clear_button_export"
        style="float: right"
        (click)="openDialogexport()"
        mat-raised-button
        color="primary"
      >
        Export
      </button>
    </div>
  </div>

  <div class="page__content shadow p-3">
    <!--class="page__content-data" remove by shivam -->
    <div class="">
      <br />
      <div class="row" style="margin-top: -40px">
        <div class="col-2 topData">
          <p>Total Farmers</p>
          <p style="font-size: 2rem">{{ totalCountData.totalFarmer }}</p>
        </div>
        <div class="col-2 topData">
          <p>Total Traders</p>
          <p style="font-size: 2rem">{{ totalCountData.totalTrader }}</p>
        </div>
        <div class="col-8 pull-right">
          <!-- <button class="clear_button" (click)="formPage()" mat-raised-button color="primary">Add New
                        Scheme</button> -->
        </div>
      </div>
      <mat-card>
        <!-- <mat-card-title>
                <p style="font-size:medium;font-weight:600;">Filters: <button class="clear_button" (click)="clearFilter()" mat-raised-button color="primary">Clear Filter</button></p>
                
              </mat-card-title> -->

        <div class="example-header">
          <mat-form-field class="full-width-field">
            <input
              matInput
              [(ngModel)]="searchdata"
              (change)="changeFn($event)"
              (keyup)="autoSuggestionUser($event)"
              placeholder="Search"
              [matAutocomplete]="auto"
            />
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngFor = "let option of userSuggesstion" [value]="option">{{ option }}</mat-option>
            </mat-autocomplete> </mat-form-field
          >&nbsp;&nbsp;
          <button
            type="submit"
            (click)="applyfilter(true)"
            class="btn btn-primary mat-primary search_bar"
          >
            <mat-icon class="search_bar_icon">search</mat-icon>
          </button>
          <hr />
          <!-- <mat-form-field>
                <input matInput [(ngModel)]="namedata" placeholder="Name">
              </mat-form-field>&nbsp; -->
          <!-- <mat-form-field>
                  <input matInput    [(ngModel)]="roledata" placeholder="Role">
                </mat-form-field>&nbsp;
                 -->
          <mat-form-field>
            <mat-label>Role</mat-label>
            <mat-select [(ngModel)]="roledata">
              <mat-option *ngFor="let food of rolebased" [value]="food.role">
                {{ food.role }}
              </mat-option>
            </mat-select> </mat-form-field
          >&nbsp;
          <!-- <mat-form-field>
                <select [(ngModel)]="roledata">
                  <option *ngFor="let c of rolebased" [ngValue]="c">{{c.role}}</option>
                </select>
              </mat-form-field> -->

          <mat-form-field (click)="suche()">
            <mat-select
              [formControl]="bankMultiCtrl"
              [(ngModel)]="statedata"
              ngDefaultControl
              placeholder="States"
              [multiple]="true"
              #multiSelect
              noEntriesFoundLabel="'no matching country found'"
            >
              <mat-option>
                <ngx-mat-select-search
                  id="search1"
                  [showToggleAllCheckbox]="true"
                  (ngModelChange)="filterMyOptions($event); notFound()"
                  [toggleAllCheckboxIndeterminate]="isIndeterminate"
                  [toggleAllCheckboxChecked]="isChecked"
                  (toggleAll)="toggleSelectAll($event)"
                  [formControl]="bankMultiFilterCtrl"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option
                *ngFor="let bank of filteredBanksMulti | async"
                [value]="bank"
              >
                {{ bank.stateName }}
              </mat-option>
            </mat-select> </mat-form-field
          >&nbsp;&nbsp;

          <mat-form-field (click)="sucheDistrict()">
            <mat-select
              [formControl]="districtMultiCtrl"
              [(ngModel)]="districtdata"
              ngDefaultControl
              placeholder="Districts"
              [multiple]="true"
              #multiSelect
            >
              <mat-option>
                <ngx-mat-select-search
                  id="search1"
                  [showToggleAllCheckbox]="true"
                  [toggleAllCheckboxIndeterminate]="isIndeterminateDistrict"
                  [toggleAllCheckboxChecked]="isCheckedDistrict"
                  (toggleAll)="toggleSelectAlldistrict($event)"
                  [formControl]="districtMultiFilterCtrl"
                  (ngModelChange)="notFoundDistrict()"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option
                *ngFor="let district of selectDistrict"
                [value]="district"
              >
                {{ district }}
              </mat-option>
            </mat-select> </mat-form-field
          >&nbsp;&nbsp;

          <!-- <mat-form-field color="accent">
            <mat-select [formControl]="bankMultiCtrl" placeholder="Distict" [multiple]="true" #multiSelect>
              <mat-option>
                <ngx-mat-select-search [showToggleAllCheckbox]="true"
                               [toggleAllCheckboxIndeterminate]="isIndeterminate"
                               [toggleAllCheckboxChecked]="isChecked"
                               (toggleAll)="toggleSelectAll($event)"
                               [formControl]="bankMultiFilterCtrl"></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let bank of filteredBanksMulti | async" [value]="bank">
                {{bank.name}}
              </mat-option>
            </mat-select>
          </mat-form-field> -->
          <!-- <mat-form-field>
            <input matInput [(ngModel)]="statedata" placeholder="State">
          </mat-form-field>&nbsp; -->
          <!-- <mat-form-field>
             <input matInput [(ngModel)]="districtdata" placeholder="District">
          </mat-form-field>&nbsp;&nbsp; -->
          <!-- <mat-form-field>
                  <input matInput   [(ngModel)]="mandidata" placeholder="Mandi" >
                </mat-form-field>&nbsp;&nbsp; -->
          <button
            class="btn btn-primary mat-primary clear_button pull-right"
            style="margin-top: 12px"
            (click)="clearFilter()"
          >
            Clear Filter
          </button>
          <button
            type="submit"
            style="margin-top: 12px; margin-right: 10px"
            (click)="applyfilter(true)"
            class="btn btn-primary mat-primary pull-right"
          >
            Apply Filter
          </button>
          <div>
            <mat-chip-list #chipList aria-label="Filter selection">
              <mat-chip
                *ngFor="let filter of matChipArray; let i = index"
                [selectable]="selectable"
                [removable]="removable"
                (removed)="remove(i, filter.tag)"
              >
                {{ filter.name }}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip>
            </mat-chip-list>
          </div>
          <div class="text_filter_data" *ngIf="exportcsvdata">
            <p *ngIf="this.userlist.length == 0">
              There's no record found with the given criteria, please try again
              refining your search and filters
            </p>
          </div>

          <!-- <mat-form-field>
                  <input matInput  placeholder="Mobile" (keyup)="filtermobile($event.target.value)">
                </mat-form-field>&nbsp; -->
        </div>
      </mat-card>
      <div class="mat-elevation-z8 position-relative" style="margin-top: 15px">
        <mat-table #table [dataSource]="dataSource" matSort>
          <!--- Note that these columns can be defined in any order.
                    The actual rendered columns are set as a property on the row definition" -->

          <!-- Position Column -->
          <!-- <ng-container matColumnDef="position">
                <mat-header-cell *matHeaderCellDef> PersonId </mat-header-cell>
                <mat-cell *matCellDef="let userlist"> {{userlist.personId}} </mat-cell>
              </ng-container> -->

          <!-- Name Column -->
          <ng-container matColumnDef="personName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              User Name
            </mat-header-cell>
            <mat-cell *matCellDef="let userlist"
              ><a
                title="View Profile"
                class="user_profile"
                (click)="openDialog(userlist)"
              >
                {{ userlist.personName }}
              </a></mat-cell
            >
          </ng-container>
          <!-- (click)="openDialog(userlist)" -->
          <!-- Weight Column -->
          <ng-container matColumnDef="role">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Role
            </mat-header-cell>
            <mat-cell *matCellDef="let userlist">
              <!--<a title="View Profile" class="user_profile" (click)="showDocument(userlist)">-->
              {{ userlist.role }}
              <!--</a>-->
            </mat-cell>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="states">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              State
            </mat-header-cell>
            <mat-cell *matCellDef="let userlist">
              <!--<a title="View Profile" class="user_profile" (click)="showDocument(userlist)"> -->{{
                userlist.states
              }}
              <!--</a>-->
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="district">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              District
            </mat-header-cell>
            <mat-cell *matCellDef="let userlist">
              <!--<a title="View Profile" class="user_profile" (click)="showDocument(userlist)"> -->{{
                userlist.district
              }}
              <!--</a>-->
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="phoneNo">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Mobile No
            </mat-header-cell>
            <mat-cell *matCellDef="let userlist">
              <!--<a title="View Profile" class="user_profile" (click)="showDocument(userlist)">-->{{
                userlist.phoneNo
              }}
              <!--</a>-->
            </mat-cell>
          </ng-container>

          <!-- <ng-container matColumnDef="Address">
                <mat-header-cell *matHeaderCellDef> View Profile </mat-header-cell>
                <mat-cell *matCellDef="let userlist"><a class="links" (click)="showDocument(userlist)">View Profile</a></mat-cell>
              </ng-container> -->

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <!-- <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row> -->
          <mat-row
            style="cursor: pointer"
            *matRowDef="let userlist; columns: displayedColumns"
          ></mat-row>
        </mat-table>

        <mat-paginator
          [length]="length"
          [pageIndex]="pageIndex"
          [pageSize]="pageSize"
          [pageSizeOptions]="[10, 20, 50, 100]"
          (page)="getServerData($event)"
          showFirstLastButtons
          aria-label=""
        >
        </mat-paginator>

        <!-- <mat-paginator 
            [length]="length"
            [pageIndex]="pageIndex"
            [hasNextPage]="hasNextPage"
            [hasPreviousPage]="hasPreviousPage"
            (page)="pageEvent = getServerData($event)"
            [pageSizeOptions]="[10]"
                 showFirstLastButtons 
                 aria-label="">
            </mat-paginator> -->
      </div>
    </div>
  </div>
</div>

<div *ngIf="pageEvent">
  <h5>Page Change Event Properties</h5>
  <div>List length: {{ pageEvent.length }}</div>
  <div>Page size: {{ pageEvent.pageSize }}</div>
  <div>Page index: {{ pageEvent.pageIndex }}</div>
</div>

<div class="container-fluid page" *ngIf="Viewprofile">
  <div class="d-flex page__box p-3 mt-2">
    <img
      src="./assets/arrow_logo.png"
      class="arrow"
      (click)="showViews()"
    />&nbsp; User Profile
  </div>
  <div class="page__content shadow p-3">
    <div class="row">
      <div class="col-md-12">
        <!-- <button type="button" style="background-color: red;
                border-color: #0d6efd;" (click)="showViews(1)"  class="btn btn-primary rejbutt">Back</button> -->
        <!-- <mat-card >
            <img mat-card-image src="https://material.angular.io/assets/img/examples/shiba2.jpg" alt="Photo of a Shiba Inu" style="height:100px;width:100px">
         </mat-card> -->
        <!-- <div class="col-md-2 profile_image">
           
           <mat-card >
            <mat-card-title style="font-size: 20px !important;">Profile Piture</mat-card-title>
            <hr>
          <img mat-card-image src="./assets/userImg.png" >
       </mat-card>
      </div> -->
        <div class="col-md-1"></div>
        <div class="profile_details">
          <!--class="profile_details"-->
          <mat-card>
            <h5></h5>
            <!-- <p><b>Person Name</b>    : {{personName}}</p>
      <p><b>Phone Number</b>   : {{phoneNo}}</p>
      <p><b>Role</b>           : {{role}}</p>
      <p><b>Mandi</b>          : {{mandi}}</p>
      <p><b>Document Staus</b> : {{documentStatus}}</p>
      <p><b>State</b> : {{states}}</p> -->
            <!-- <div *ngIf="datashowtrader"> -->
            <!---Trader Details -->
            <!-- <p><b>State</b> : {{states}}</p> -->
            <!---Trader Details -->
            <!-- </div> -->
            <!---For farmer -->
            <div
              class="profile_image"
              style="float: right; margin-top: 12px; margin-right: 100px"
            >
              <!-- <h5 style="margin-left: 20px;">Profile Photo</h5> -->
              <!-- <img mat-card-image src="./assets/userImg.png" > -->
              <!-- <img mat-card-image src="{{profile_Image}}" > -->
              <div *ngIf="avtar; else loggedOut">
                <img mat-card-image src="./assets/userImg.png" />
              </div>
              <ng-template #loggedOut>
                <img mat-card-image src="{{ profile_Image }}" />
              </ng-template>
              <div *ngIf="documentStatus == 'Verified'">
                <img
                  src="./assets/verified.png"
                  style="height: 39px; margin-left: 13px"
                />
                <p class="text_verified">
                  <b style="font-size: 18px">Verified</b>
                </p>
              </div>
            </div>

            <div>
              <div *ngIf="datashowfarmer">
                <p><b>Farmer Name</b> : {{ personName }}</p>
                <p><b>Role</b> : {{ role }}</p>
                <p><b>Village</b> : {{ village }}</p>
                <p><b>Taluk</b> : {{ taluk }}</p>
                <p><b>District</b> : {{ district }}</p>
                <p><b>State</b> : {{ states }}</p>
                <p><b>Mobile Number</b> : {{ phoneNo }}</p>
                <!-- <p><b>Mandi</b>          : {{mandi}}</p> -->
                <p><b>No Of Trees</b> : {{ numberOfTrees }}</p>
                <p><b>Types of Trees</b> : {{ treeType }}</p>
                <p><b>Customer Id </b> : {{ treeType }}</p>
              </div>
              <!---For farmer -->
              <!--For Traders -->
              <div *ngIf="datashowtrader">
                <p><b>Trader Name</b> : {{ personName }}</p>
                <p><b>Company </b> : {{ personName }}</p>
                <p><b>Role</b> : {{ role }}</p>
                <p><b>Address</b> : {{ address }}</p>
                <p><b>District</b> : {{ district }}</p>
                <p><b>State</b> : {{ states }}</p>
                <p><b>Mobile Number</b> : {{ phoneNo }}</p>
                <p><b>Email</b> : {{ email }}</p>
                <p><b>Mandi</b> : {{ mandi }}</p>
                <p>
                  <b>Commodity trade interested</b>: {{ commTradeInterest }}
                </p>
                <p><b>Frequency for requirement</b> : {{ reqFrequency }}</p>
                <p><b>About the trader</b> : {{ aboutUs }}</p>
              </div>
            </div>
            <!--For Traders -->
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
